'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$uibModal',
    function ($modal) {

        return {
            select: select,
            create: create,
            edit: edit,
            remove: remove
        };

        // region Function

        function select(project, filters, def) {
        }

        function create(output, edit) {
            return $modal.open({
                template: require('../view/project-output-modal-create.html'),
                controller: 'ProjectOutputModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    output: function () {
                        return output;
                    },
                    edit: function () {
                        return edit;
                    }
                }
            });
        }

        function edit(output, edit) {
            return $modal.open({
                template: require('../view/project-output-modal-create.html'),
                controller: 'ProjectOutputModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    output: function () {
                        return output;
                    },
                    edit: function () {
                        return edit;
                    }
                }
            });
        }

        function remove(project, callback) {
        }

        // endregion

    }];